<img src="../../../../assets/images/SPACE AR small.png" style="width:100px;margin-left:20px;"/>

<div style="margin-top:10px;"><span style="margin-left:20px;font-size:18px;font-weight: bold;;">{{data.dlgTitle}}</span></div>
<div>

    <div style="margin-top:20px;margin-left:20px;margin-bottom:15px;">
        @if(data.dlgLine1 != ''){
            {{data.dlgLine1}}
        }
        
        @if(data.dlgLine2 != ''){
            <br />
            <br />
            {{data.dlgLine2}}
        }
    </div>
    
</div>

<!-- <img src="../../../../assets/icons/red-warning-triangle.png" style="height:30px;width:30px;margin-left:15px;top:40px;position:relative;"> -->
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false" style="background-color:#003087 !important;color:white !important">OK</button>
</div>
